<template>
	<svg
		id="Layer_2"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 230 80"
		:style="cssVars"
	>
		<g id="bg-dark-and-gold">
			<rect id="bg" class="cls-3" x="5" y="5" width="220" height="70" />
			<polygon id="left" class="cls-4" points="5 5 0 0 0 80 5 75 5 5" />
			<polygon
				id="top"
				class="cls-1"
				points="225 5 230 0 0 0 5 5 225 5"
			/>
			<polygon
				id="right"
				class="cls-4"
				points="225 5 225 75 230 80 230 0 225 5"
			/>
			<polygon
				id="bottom"
				class="cls-2"
				points="5 75 0 80 230 80 225 75 5 75"
			/>
		</g>
	</svg>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const { skin } = defineProps<{
	skin: "red" | "yellow";
}>();

const skinColors = computed<{
	cls1: string;
	cls2: string;
	cls3: string;
	cls4: string;
}>((): { cls1: string; cls2: string; cls3: string; cls4: string } => {
	if (skin === "yellow") {
		return {
			cls1: "#96824d",
			cls2: "#cdb066",
			cls3: "#27282b",
			cls4: "#f6db93",
		};
	}
	if (skin === "red") {
		return {
			cls1: "#9d2829",
			cls2: "#ff6464",
			cls3: "#27282b",
			cls4: "#d63435",
		};
	}
	return {
		cls1: "#fff",
		cls2: "#fff",
		cls3: "#fff",
		cls4: "#fff",
	};
});
const cssVars = computed(() => {
	return {
		"--color-1": skinColors.value.cls1,
		"--color-2": skinColors.value.cls2,
		"--color-3": skinColors.value.cls3,
		"--color-4": skinColors.value.cls4,
	};
});
</script>

<style lang="scss" scoped>
.cls-1 {
	fill: var(--color-1);
}
.cls-2 {
	fill: var(--color-2);
}
.cls-3 {
	fill: var(--color-3);
}
.cls-4 {
	fill: var(--color-4);
}
</style>
